import {observable, action} from 'mobx';
import _ from 'lodash';
import moment from 'moment'
// import { EditorState, ContentState } from 'draft-js';
// import htmlToDraft from 'html-to-draftjs';
import {TARGET_AUDIENCES_MULTISELECT} from 'components/create_workshop/constants';
import OnlineWorkshopService from "../services/OnlineWorkshopService";
const DATES_KEYS = ['end_date', 'end_time', 'start_date', 'start_time'];

class RegularWorkshopCreate {
  constructor() {
    this.setInitialState();
  }

  @action setInitialState = () => {
    this.workshopService = new OnlineWorkshopService();
    this.modulePosition = '',
    this.openedEntity = { type: "in_person" };
    this.modules = [];
    this.workshop = {
      workshop_type: 'in_person',
      title: '',
      summary: '',
      description: '',
      start_date: null,
      end_date: null,
      start_time: null,
      end_time: null,
      venue_name: '',
      venue_county: '',
      venue_address: '',
      venue_postcode: '',
      provided_by: '',
      provider_bio: '',
      provider_logo: null,
      host: '',
      contact_name: '',
      contact_email: '',
      contact_phone: '',
      more_info: null,
      fee: false,
      limited_purchase: false,
      tickets_count: "",
      cost: '',
      website: '',
      target_audience: [],
      cpd_hours: false,
      how_many_hours: '',
      bought: false,
    };
    this.modulesError = [];
    this.errors = [];
    this.questionsMap = new Map();
    this.modulesDetailsMap = new Map();
    this.moduleDescriptionFile = [];
    this.questionDetailsFiles = [];
    this.entityToSave = null;
  };

  @observable workshop = {};

  @observable documents = [];

  @observable modules = [];

  @observable openedType = { type: "in_person" };

  @observable entityToSave = null;

  @observable openedEntity = { type: "in_person" };

  @observable modulesState = new Map();

  @observable questionState = new Map();

  @observable errors = {};

  @action setCouponError = (newCouponErrors) => {
    this.couponErrors = newCouponErrors;
  }

  @action setQuizCount = (index, count) => {
    const emptyObjects = [...Array(count).fill().map(() => ({...{}}))];
    this.modules[index].questions_attributes = emptyObjects;
  };

  @action setQuiz = (index, q_index, data) => {
    if (!this.modules[index].questions_attributes.length) {
      const emptyObjects = [{}];
      this.modules[index].questions_attributes = emptyObjects;
    }

    this.modules[index].questions_attributes[q_index].text = data.text;
    this.modules[index].questions_attributes[q_index].correct =
      data.correct;

    // this.modules[index].questions_attributes[q_index].text =
    // data.textQuestion;
    // this.modules[index].questions_attributes[q_index].correct = String(
    // data.rightAnswer
  };

  @action clearQuestions_attributes = (index, type) => {
    this.modules[index].module_type = type;

    let currentModule = [...this.modules[index].questions_attributes];
    let deleteQuestionsIds = currentModule.map(question => question.id);
    deleteQuestionsIds = deleteQuestionsIds.filter(id => id);
    this.modules[index].questions_attributes = [];
    if (this.workshop.deleteThisIds) {
      this.workshop.deleteThisIds = this.workshop.deleteThisIds.concat(deleteQuestionsIds);
    } else {
      this.workshop.deleteThisIds = deleteQuestionsIds
    }
    // console.log('Deleted indexes are: ', this.workshop.deleteThisIds);

    // console.log("All questions erased!!");
  };

  @action handleChange = data => {
    this.workshop = _.assign({}, this.workshop, data);
  };

  @action addModuleError = data => {
    this.modulesError.push(_.assign(data, { questionError: [] }));
  };

  @action removeModuleError = index => {
    if (this.modulesError.length > index)
      this.modulesError[index] = _.assign(
        {},
        { questionError: this.modulesError[index].questionError }
      );
  };

  @action clearModuleError = () => {
    this.modulesError = [];
  };

  @action
  handleChangeOpenedEntity = data => {
    this.openedEntity = data;
  };

  getModules = () => {
    const sortedModules = this.modules.sort((module_a, module_b) => (module_a.position_index || module_a.id) - (module_b.position_index || module_b.id));
    return sortedModules || [];
  };

  getWorkShop = () => {
    return this.workshop;
  };

  getErrors = () => {
    return this.errors;
  };

  @action addEmptyModule = key => {
    this.modules.push({
      id: null,
      title: "",
      summary: "",
      details: "",
      position_index: "",
      documents: [],
      key: key,
      is_hidden: false,
      module_type: "quiz",
      questions_attributes: [],
      openedQuestion: -1,
      attachments_attributes: []
    });
    this.handleChangeOpenedEntity({ type: "module", id: key });
  };

  @action handleModuleChange = (data, index) => {
    let module = this.modules[index];
    const isPositionIndex = Object.keys(data)[0] === 'position_index';
    if(isPositionIndex) {
      if(!!module.position_index) {
        this.modulePosition = module.position_index;
      }
      if(this.modulePosition) {
        this.modules.forEach((prevModule, prevModuleIndex) => {
          if(Number(prevModule.position_index) === Number(data.position_index)) {
            this.modules[prevModuleIndex] = {
              ...this.modules[prevModuleIndex],
              position_index: this.modulePosition,
            };
          }
        });
      }
      this.modules[index] = {
        ...this.modules[index],
        position_index: data.position_index,
      };
    } else {
      _.assign(module, data);
    }
  };

  @action
  addQuestion = (index, key) => {
    this.modules[index].questions_attributes.push({
      key: key,
      text: "",
      attachments_attributes: []
    });
    this.openQuestion(index, key);
  };

  @action deleteModule = key => {
    let index = _.findIndex(this.modules, el => el.key === key);
    if (this.modulesError.length > index) this.modulesError.splice(index, 1);
    this.modules.splice(index, 1);
  };

  @action handleChangeQuestion = (module, question, data) => {
    _.assign(this.modules[module].questions_attributes[question], data);
  };

  @action addQuestionFile = (module, question, data) => {
    this.modules[module].questions_attributes[
      question
    ].attachments_attributes.push(_.assign({}, data));
  };

  @action openQuestion = (module, questionKey) => {
    this.modules[module] = _.assign(this.modules[module], {
      openedQuestion: questionKey
    });
  };

  @action deleteQuestionFile = (module, question, fileIndex) => {
    this.modules[module].questions_attributes[
      question
    ].attachments_attributes.splice(fileIndex, 1);
  };

  @action deleteQuestion = (module, question) => {
    if (this.modulesError.length > module)
      if (this.modulesError[module].questionError.length > question)
        this.modulesError[module].questionError.splice(question, 1);
    this.modules[module].questions_attributes.splice(question, 1);
  };

  @action
  addModuleFile = (moduleId, file) => {
    this.modules[moduleId].attachments_attributes.push(_.assign({}, file));
  };

  @action
  deleteModuleFile = (moduleId, fileId) => {
    this.modules[moduleId].attachments_attributes.splice(fileId, 1);
  };

  @action
  addQuestionError = (index, data) => {
    if (this.modulesError.length > index)
      this.modulesError[index].questionError.push(data);
  };

  @action
  removeQuestionError = (index, questionId) => {
    if (this.modulesError.length > index)
      this.modulesError[index].questionError[questionId] = {};
  };

  @action
  addFileToModule = object => {
    this.moduleDescriptionFile.push(object);
  };

  @action
  addFileToModuleDetails = (index, object) => {
    if (!this.modulesDetailsMap.has(index))
      this.modulesDetailsMap.set(index, { files: [object] });
    else {
      this.modulesDetailsMap.get(index).files.push(object);
    }
  };

  @action
  addFileToQuestionText = (moduleIndex, questionIndex, object) => {
    let key = `${moduleIndex}${questionIndex}`;
    if (!this.questionsMap.has(key)) {
      this.questionsMap.set(key, { files: [object] });
    } else {
      this.questionsMap.get(key).files.push(object);
    }
  };

  @action addErrors = err => {
    this.errors = _.assign({},this.errors, err);
  };

  @action clearErrors = () => {
    this.errors = {};
  };

  @action addFileToRegular = data => {
   this.documents.push(data)
  };

  @action updateWorkshop = data => {
    let workshop = {};
    _.mapKeys(data, (value, key) => {
      if(DATES_KEYS.includes(key) && value){
        _.assign(workshop, {[key]: moment(value)})
      }

      else if(key === 'target_audience'){
        let newtargetAudience = [];
        console.log('data.target_audience', data.target_audience);
        data.target_audience.forEach(target => {
          newtargetAudience.push({value: this.getTartgetByValue(target), label: target})
        });
        workshop = _.assign({}, workshop, {target_audience: newtargetAudience})
      }

      else if(key === 'description')
        _.assign(workshop, {[key]: value});
      else  _.assign(workshop, {[key]: value ? value: ''})
    });
    if(data.more_info_file_name)
      _.assign(workshop, {
        more_info: 1,
        file_name: data.more_info_file_name,
        file_size: data.more_info_file_size, key: 1});
    this.workshop = {
      ...{modules: []},
      ...workshop,
    };
    console.log('this.workshop', this.workshop);
  };

  @action setModules = modules => {
    this.modules = this.workshopService.setModules(modules);
  };



  // htmlToDrafJs = html => {
  //   const {contentBlocks, entityMap} = htmlToDraft(html);
  //   const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
  //   return EditorState.createWithContent(contentState);
  // };


  @action
  handleChangeTargetAudience = data => {
    this.workshop.target_audience.push(data);
  };

  getTartgetByValue = target => {
    let value = -1;
    TARGET_AUDIENCES_MULTISELECT.forEach(e => {
      if(e.label === target)
        value = e.value
    });
    return value;
  };

  @action addErrorToBio = () => {
    this.errors = _.assign({}, this.errors, {provider_bio: ['Provider bio maximum 1000 symbols']})
  };

  @action removeLogo = () => {
    this.workshop.provider_logo = null;
    this.workshop.provider_logo_url = null;
  };

  showRemoveLogo = () => {
    return (this.workshop.provider_logo || this.workshop.provider_logo_url   );
  }
}

export default new RegularWorkshopCreate();



// WEBPACK FOOTER //
// ./src/stores/RegularWorkshopCreate.js